<template>
  <div class="m-auto max-w-screen-lg flex flex-col space-y-8 lg:flex-row lg:space-y-0 justify-between items-center bg-gray-800 text-white">
    <div class="p-4 leading-5 whitespace-normal overflow-hidden">
      This is an unofficial viewer for Diabotical leaderboards.<br class="hidden lg:inline" />
      The data source: <a class="break-all text-blue-300 hover:text-blue-200" href="https://www.diabotical.com/leaderboards" target="_blank">https://www.diabotical.com/leaderboards</a>
    </div>
    <div class="flex items-center justify-center">
      Share:
      <span class="ya-share2 ml-1" data-services="twitter,facebook,vkontakte" data-counter="data-counter" data-size="s" />
    </div>
    <div class="flex items-center justify-center">
      Donate:
      <a class="ml-1 cursor-pointer opacity-100 hover:opacity-75" href="https://paypal.me/danmer" target="_blank"><img class="h-5 w-5" src="../assets/paypal.png" alt=""/></a>
      <a class="ml-1 cursor-pointer opacity-100 hover:opacity-75" href="https://money.yandex.ru/to/41001698799375" target="_blank"><img class="h-5 w-5" src="../assets/yandex.png" alt="" style="margin-left: .1em;"/></a>
    </div>
    <div class="p-4">&copy; <a class="text-blue-300 hover:text-blue-200" href="https://vk.com/quakelife" target="_blank">Danmer</a>, 09.2020</div>
  </div>
</template>

<script>
  export default {
    name: 'LeaderboardFooter',
  }
</script>
